const styles = theme => ({
 table:{
     width: '100%',
     borderSpacing: '0px',
     marginBottom: '10px',
     border: '1px solid #e0e0e0'
 },
    tableHeader:{
        backgroundColor: '#43415c',
        borderBottomWidth: '10px',
        height: '57px'
    },
    tableHeaderCell:{
        padding: '15px 10px',
        fontSize: '13px',
        color: '#fff',
        fontFamily: 'AvenirNext',
        fontStyle: 'normal',
        textTransform: 'uppercase',
        fontWeight: 'normal',
        position: 'relative',
        backgroundColor: '#43415c'
    },
    tableRow:{
     border: '1px solid #f0f0ff',
     maxHeight: '50px'
    },
    tableCell:{
        padding: '15px 10px',
        "fontFamily": "AvenirNext",
        "fontSize": "12px",
        "fontWeight": "500",
        "fontStretch": "normal",
        "fontStyle": "normal",
        "lineHeight": "normal",
        "letterSpacing": "normal",
        "color": "#4a4a4a"
    },

});

export default styles;
